import { Grid } from "@mui/material";
import React from "react";
import JExpenseHeader from "./home/header";
import JExpenseTable from "./home/table";

const JExpense = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JExpenseHeader />
      </Grid>
      <Grid item xs={12}>
        <JExpenseTable />
      </Grid>
    </Grid>
  );
};

export default JExpense;
